import type { OptionFetcher } from '@eo/shared';

import getApiHttpClient from '../../../httpClients/getApiHttpClient';
import type {
  CapacityClientRow,
  CapacityEntryRow,
  CapacityReport,
  ClientListParams,
  ClientOption,
  EntryListParams,
  PaginationMeta,
  PersonOption,
  SyncResult,
} from './types';

export async function fetchReport(month: string, owner?: string): Promise<CapacityReport> {
  const res = await getApiHttpClient().get<CapacityReport>('/api/v1/cfo/capacity/report', {
    params: { month, owner },
  });
  return res.data;
}

export async function fetchClientRows(
  month: string,
  owner: string | undefined,
  params: ClientListParams,
): Promise<{ clients: CapacityClientRow[]; pagination: PaginationMeta }> {
  const res = await getApiHttpClient().get<{
    clients: CapacityClientRow[];
    pagination: PaginationMeta;
  }>('/api/v1/cfo/capacity/clients', { params: { month, owner, ...params } });
  return res.data;
}

export async function fetchEntryRows(
  month: string,
  owner: string | undefined,
  params: EntryListParams,
): Promise<{ entries: CapacityEntryRow[]; pagination: PaginationMeta }> {
  const res = await getApiHttpClient().get<{
    entries: CapacityEntryRow[];
    pagination: PaginationMeta;
  }>('/api/v1/cfo/capacity/entries', { params: { month, owner, ...params } });
  return res.data;
}

export async function syncMonth(month: string): Promise<{ results: SyncResult[] }> {
  const res = await getApiHttpClient().post<{ results: SyncResult[] }>(
    '/api/v1/cfo/capacity/sync',
    { month },
  );
  return res.data;
}

// The portfolio's clients, searched by the registry route; the filters carry
// the portfolio's owner when the page is on one.
export const searchClients: OptionFetcher = async ({ search, page, filters }) => {
  const res = await getApiHttpClient().get<{
    clients: ClientOption[];
    pagination: PaginationMeta;
  }>('/api/v1/cfo/clients', {
    params: { active: true, ...(search && { search }), page, ...filters },
  });
  return { items: res.data.clients, pagination: res.data.pagination };
};

export const searchPeople: OptionFetcher = async ({ search, page }) => {
  const res = await getApiHttpClient().get<{
    people: PersonOption[];
    pagination: PaginationMeta;
  }>('/api/v1/cfo/capacity/people', { params: { ...(search && { search }), page } });
  return { items: res.data.people, pagination: res.data.pagination };
};
